// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1n6PH","rootCenter":"LoadMoreObserver_rootCenter__100qW","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3fNpn"};